export const authShellSx = {
  minHeight: '100dvh',
  bgcolor: '#FEFEFE',
  alignItems: 'stretch',
};

export const authMarketingPanelSx = {
  minHeight: { xs: 'auto', md: '100dvh' },
  px: { xs: 2, sm: 3, md: 4, lg: 6, xl: 7 },
  py: { xs: 4, sm: 5, md: 6, lg: 7 },
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  color: '#FFFFFF',
  background: 'linear-gradient(160deg, #294190 0%, #3A5FA0 28%, #4F8506 100%)',
};

export const authMarketingInnerSx = {
  width: '100%',
  maxWidth: { xs: 560, md: 520, lg: 560 },
  mx: 'auto',
};

export const authBrandSx = {
  fontFamily: 'Montserrat, Roboto, "Helvetica Neue", Arial, sans-serif',
  fontSize: { xs: '2.5rem', sm: '3.1rem', md: '3.6rem', lg: '4.25rem' },
  lineHeight: 1,
  fontWeight: 800,
  letterSpacing: '-0.04em',
  color: '#FFFFFF',
};

export const authHeadlineSx = {
  mt: 1,
  fontFamily: 'Montserrat, Roboto, "Helvetica Neue", Arial, sans-serif',
  fontSize: { xs: '1.5rem', sm: '1.85rem', md: '2.2rem', lg: '2.5rem' },
  lineHeight: 1.1,
  fontWeight: 700,
  letterSpacing: '-0.02em',
  color: 'rgba(255, 255, 255, 0.98)',
};

export const authSubheadlineSx = {
  mt: 1,
  maxWidth: 420,
  mx: 'auto',
  fontSize: { xs: '0.95rem', sm: '1rem' },
  lineHeight: 1.5,
  fontWeight: 400,
  letterSpacing: '0.02em',
  color: 'rgba(255, 255, 255, 0.86)',
};

export const authCapabilitiesWrapSx = {
  display: 'grid',
  width: '100%',
  gap: { xs: 1.25, sm: 1.5, md: 2.25 },
  gridTemplateColumns: {
    xs: 'repeat(2, minmax(0, 1fr))',
    sm: 'repeat(2, minmax(0, 1fr))',
    md: '1fr',
  },
  justifyItems: 'center',
};

export const authCapabilityPillSx = {
  width: { xs: '100%', md: 'min(100%, 280px)' },
  maxWidth: { xs: 220, sm: 240, md: 280 },
  px: { xs: 2, sm: 2.5, md: 3 },
  py: { xs: 1.5, md: 2 },
  borderRadius: '999px',
  border: '1px solid rgba(255, 255, 255, 0.22)',
  background: 'rgba(255, 255, 255, 0.12)',
  backdropFilter: 'blur(10px)',
  color: '#FFFFFF',
  fontSize: { xs: '0.82rem', sm: '0.92rem', md: '1rem' },
  lineHeight: 1.4,
  fontWeight: 600,
  letterSpacing: { xs: '0.05em', md: '0.08em' },
  textTransform: 'uppercase',
};

export const authFormPanelSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: { xs: 'auto', md: '100dvh' },
  px: { xs: 2, sm: 3, md: 4, lg: 6, xl: 8 },
  py: { xs: 3, sm: 4, md: 6 },
};

export const authCardSx = {
  width: '100%',
  maxWidth: { xs: '100%', sm: 540, lg: 560 },
  borderRadius: { xs: '22px', sm: '28px' },
  border: '1px solid #E7ECF2',
  backgroundColor: '#FFFFFF',
  boxShadow: '0px 24px 60px rgba(28, 27, 31, 0.08)',
  px: { xs: 2.5, sm: 4, md: 4.5 },
  py: { xs: 3, sm: 4.5, md: 5 },
};

export const authTitleSx = {
  fontFamily: 'Montserrat, Roboto, "Helvetica Neue", Arial, sans-serif',
  fontSize: { xs: '1.75rem', sm: '2.1rem', md: '2.4rem' },
  lineHeight: 1.15,
  fontWeight: 700,
  letterSpacing: '-0.02em',
  color: '#1C1B1F',
};

export const authSubtitleSx = {
  mt: 1,
  fontSize: { xs: '0.95rem', sm: '1rem' },
  lineHeight: 1.5,
  color: '#625B71',
  fontWeight: 400,
  letterSpacing: '0.15px',
};

export const authCardHeaderSx = {
  pb: { xs: 3, sm: 4 },
  textAlign: 'center',
};

export const authLogoSx = {
  width: { xs: 52, sm: 64 },
  height: 'auto',
  objectFit: 'contain',
  mb: 1.25,
};

export const authFormGridSx = {
  rowSpacing: { xs: 2.5, sm: 3 },
};

export const authLabelSx = {
  display: 'block',
  mb: 1,
  position: 'static',
  transform: 'none',
  transformOrigin: 'top left',
  fontSize: 14,
  lineHeight: '16px',
  letterSpacing: '0.4px',
  fontWeight: 500,
  color: '#1C1B1F',
};

export const authFieldSx = {
  '& .MuiOutlinedInput-root': {
    minHeight: 56,
    borderRadius: '12px',
    backgroundColor: '#FFFFFF',
    '& fieldset': {
      borderColor: '#E4E6F1',
    },
    '&:hover fieldset': {
      borderColor: '#D2D6E8',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#4F8506',
      borderWidth: '1px',
    },
  },
  '& .MuiInputBase-input': {
    fontSize: 16,
    lineHeight: '24px',
    letterSpacing: '0.5px',
    color: '#1C1B1F',
    fontWeight: 400,
  },
  '& .MuiInputBase-input::placeholder': {
    color: '#625B71',
    opacity: 1,
    fontWeight: 400,
  },
  '& .MuiFormHelperText-root': {
    ml: 0,
    mt: 1,
    fontSize: 12,
    lineHeight: '16px',
    letterSpacing: '0.4px',
  },
};

export const authPrimaryButtonSx = {
  minHeight: 52,
  borderRadius: '12px',
  backgroundColor: '#4F8506',
  color: '#FFFFFF',
  textTransform: 'none',
  fontSize: '1rem',
  lineHeight: 1.5,
  letterSpacing: '0.15px',
  fontWeight: 600,
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: '#4F8506',
    boxShadow: 'none',
  },
};

export const authForgotPasswordSx = {
  cursor: 'pointer',
  color: '#294190',
  fontSize: 15,
  lineHeight: '20px',
  letterSpacing: '0.1px',
  fontWeight: 500,
  textAlign: 'center',
};

export const authSecondaryButtonSx = {
  minHeight: 52,
  borderRadius: '12px',
  borderColor: '#294190',
  color: '#294190',
  textTransform: 'none',
  fontSize: '1rem',
  lineHeight: 1.5,
  letterSpacing: '0.15px',
  fontWeight: 600,
  px: 3,
  '&:hover': {
    borderColor: '#294190',
    backgroundColor: 'rgba(41, 65, 144, 0.04)',
  },
};

export const requiredAsteriskSx = {
  color: '#DA342E',
};
